import Cabang from "../../../../../components/categories/siakad/lms/data_cabang/Home";
export default function Home() {
  
  return (
    <Cabang />
  );
}
